import { render } from "./FieldMappingsTab.vue?vue&type=template&id=4ebe5c75&scoped=true"
import script from "./FieldMappingsTab.vue?vue&type=script&lang=js"
export * from "./FieldMappingsTab.vue?vue&type=script&lang=js"

import "./FieldMappingsTab.vue?vue&type=style&index=0&id=4ebe5c75&scoped=true&lang=css"
import "./FieldMappingsTab.vue?vue&type=style&index=1&id=4ebe5c75&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ebe5c75"]])

export default __exports__